import React, { memo, useMemo } from "react";
import { Link } from "../../utils/link";
import Country from "./Country";
import Signup from "./Signup";
import { Slice } from "gatsby";
import { useDispatch, useSelector } from "react-redux";
import { LOGGEDIN } from "../../constants/auth";
import { userLoggedOut } from "../../slices/auth";
import { getCurrentPath } from "../../utils/getCurrentPath";
import { Sheet, SheetTrigger } from "@/components/ui/sheet";
import HelpLinks from "./Help";

const CLUB_ACTIVE = process.env.GATSBY_CLUB_ACTIVE;

const AnnouncementBar = ({
  title,
  bgImage,
  helpLinks,
  footerLinks,
  contactDetails,
}) => {
  const { authState } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const isPartnersClub = CLUB_ACTIVE === "club_pt";

  const handleLogout = useMemo(() => {
    return () => {
      dispatch(userLoggedOut());
    };
  }, [dispatch]);

  return (
    <div
      className={`${
        isPartnersClub ? "bg-partner" : "gradientBg"
      } absolute w-full z-10 flex flex-col justify-center h-10 text-white`}
    >
      <div className="flex flex-wrap text-sm font-bold items-center mx-5 lg:mx-10 xl:mx-[90px]">
        {!isPartnersClub && (
          <>
            <div className="hidden md:block md:flex-[0.33]">
              <Country />
            </div>
            <Slice alias="announcements" />
          </>
        )}
        {isPartnersClub && (
          <>
            <div className="hidden md:block md:flex-[0.66]"></div>
          </>
        )}
        {authState === LOGGEDIN ? (
          <div className="hidden md:flex md:flex-[0.33] items-center justify-end text-xs leading-3 tracking-wide gap-3">
            <Link to="/pages/bushbuck-club" className="no-underline">
              <span className="hover:underline hover:underline-offset-[6px] text-white font-bold">
                My Account
              </span>
            </Link>
            <span className="font-light">|</span>
            <Sheet>
              <SheetTrigger
                className={`relative flex items-center group-hover:text-[#111] group-hover:hover:text-secondary-500 cursor-pointer`}
                role="button"
                title="Menu"
                asChild
              >
                <span className="hover:underline hover:underline-offset-[6px] text-white font-bold">
                  Help
                </span>
              </SheetTrigger>
              <HelpLinks
                title={title}
                bgImage={bgImage}
                helpLinks={helpLinks}
                footerLinks={footerLinks}
                contactDetails={contactDetails}
              />
            </Sheet>
            <span className="font-light">|</span>
            <button
              className="bg-transparent"
              onClick={handleLogout}
              style={{ textDecoration: "none" }}
            >
              <span className="hover:underline hover:underline-offset-[6px] text-white font-bold">
                Logout
              </span>
            </button>
          </div>
        ) : (
          <div className="hidden md:flex md:flex-[0.33] items-center justify-end text-xs leading-3 tracking-wide gap-3">
            <Link
              to="/account/login"
              state={{ redirectTo: getCurrentPath() }}
              className="no-underline"
            >
              <span className="hover:underline hover:underline-offset-[6px] text-white font-bold">
                Login
              </span>
            </Link>
            <span className="font-light">|</span>
            <Sheet>
              <SheetTrigger
                className={`relative flex items-center group-hover:text-[#111] group-hover:hover:text-secondary-500 cursor-pointer`}
                role="button"
                title="Menu"
                asChild
              >
                <span className="hover:underline hover:underline-offset-[6px] text-white font-bold">
                  Help
                </span>
              </SheetTrigger>
              <HelpLinks
                title={title}
                bgImage={bgImage}
                helpLinks={helpLinks}
                footerLinks={footerLinks}
                contactDetails={contactDetails}
              />
            </Sheet>
            <span className="font-light">|</span>
            <Signup />
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(AnnouncementBar);
